export default {
  styleOverrides: {
    root: {
      padding: 0,
      cursor: 'pointer'
    }
  }
}
